import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Modal from '@/components/main/modal.vue'
import Navbar from '@/components/main/navbar.vue'
import AppFooter from '@/components/main/footer.vue'
import { localstore, session } from '@/utils/localstorage'
import { currency_formats, InitCheckout } from '@/utils/checkout'
import {config} from "@/conf";

// get url arguments

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const args = new URLSearchParams(window.location.search)

// get gclid and save if defined
const gclid = args.get('gclid')
if (gclid) {
  session.set('gclid', 'gclid' + gclid)
} else {

  // get gbraid and save if defined
  const gbraid = args.get('gbraid')
  if (gbraid) {
    session.set('gclid', 'gbraid' + gbraid)
  } else {

    // get wbraid and save if defined
    const wbraid = args.get('wbraid')
    if (wbraid) {
      session.set('gclid', 'wbraid' + wbraid)
    }
  }
}

// get currency from args
let currency = args.get('c')
// get currency from local storage if args is undefined
if (!currency) {
  currency = localstore.get('currency') || 'eur'
}
// force lowercase
currency = currency!.toLowerCase()
// if currency not supported, set to euro
if (!currency_formats[currency]) {
  currency = 'eur'
}
// save to local storage
localstore.set('currency', currency)

if (config.lang.iso === 'ar' || config.lang.iso === 'he') {
  document.body.classList.add('rtl')
}

// init checkout
InitCheckout()


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar),
    _createVNode(_component_router_view),
    _createVNode(AppFooter),
    _createVNode(Modal)
  ], 64))
}
}

})